import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { Fragment, useMemo } from 'react';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { NBSP } from '~/common/constants';
import { CuriosityLinkChip, CuriosityLinkChipProps } from '~/components/CuriosityLinkChip/CuriosityLinkChip';

export type CuriosityLinkChipValue = Union.Nullable<string>;

interface CuriosityLinkChipCellProps<R extends GridValidRowModel = any> {
  value: CuriosityLinkChipValue | CuriosityLinkChipValue[];
  row: R;
  ns?: CuriosityNamespaceType;
  chipVariant?: CuriosityLinkChipProps['chipVariant'];
}

export const CuriosityLinkChipCell = <R extends GridValidRowModel = any>({
  value: valueProp,
  ns = CuriosityNamespaceType.COMMODITY_GROUP,
  chipVariant,
}: CuriosityLinkChipCellProps<R>) => {
  const values: CuriosityLinkChipCellProps<R>['value'] = useMemo(() => {
    if (valueProp) {
      return Array.isArray(valueProp) ? valueProp : [valueProp];
    }
    return null;
  }, [valueProp]);

  if (values) {
    const items = values
      .map((value, index: number) => {
        if (value) {
          return (
            <Fragment key={index}>
              {index > 0 ? NBSP : null}
              <CuriosityLinkChip chipVariant={chipVariant} key={index} i18nKey={value} ns={ns} />
            </Fragment>
          );
        }
        return null;
      })
      .filter(Boolean);

    if (items.length) {
      return <>{items}</>;
    }
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
